import { deserialize, serialize } from "serializr";
import { NotificationTypes } from "../../../enums/notificationTypes";
import axiosInstance from "../../../interceptor/axiosInstance";
import { ExamExerciseModel } from "../../../models/ExamModels/ExerciseModel/exercise.model";
import { ExerciseModal } from "../../../models/ExerciseModal/Exercise.model";
import { BULK_EXAM_EXERCISE_QUESTIONS, EXAM_SUBJECT_CHAPTER_EXERCISES_LIST } from "../../../routes/routeConstants/apiRoutes";
import Notification from "../../../shared/components/Notification";

export class ExamExerciseService {
    static fetchExamExercises(
        queryParams: any,
        onSuccess: Function,
        onError: Function
    ) {
        return axiosInstance.
        get(EXAM_SUBJECT_CHAPTER_EXERCISES_LIST, {
            params: queryParams 
        })
        .then(response => {
            const exercises = deserialize(ExerciseModal, response["data"]["exam_exercises"])
            onSuccess(exercises)
        })
        .catch(error => {
            onError(error)
        })
    }

    static deleteExamExercise (
        id: any,
        onSuccess: Function,
        onError: Function
    ) {
        return axiosInstance
        .delete(EXAM_SUBJECT_CHAPTER_EXERCISES_LIST + `/${id}`)
        .then(response => { 
            onSuccess(response)
        })
        .catch(error => {
            onError(error)
        })
    }

    static updateExamExercise (
        id: any,
        data: any,
        onSuccess: Function,
        onError: Function
    ) {
        const serializeData = serialize(ExamExerciseModel, data)
        const payload = { exam_exercise: serializeData}
        return axiosInstance
        .put(EXAM_SUBJECT_CHAPTER_EXERCISES_LIST + `/${id}`, payload)
        .then(response => { 
            onSuccess(response)
        })
        .catch(error => {
            onError(error)
        })
    }

    static createNewExamExercise (
        data: any,
        onSuccess: Function,
        onError: Function
    ) {
        const serializeData = serialize(ExamExerciseModel, data)
        const payload = { exam_exercise: serializeData}
        console.log(payload)
        return axiosInstance
        .post(EXAM_SUBJECT_CHAPTER_EXERCISES_LIST, payload)
        .then(response => { 
            const exercise =  deserialize(ExerciseModal, response["data"]["exam_exercise"])
            onSuccess(exercise)
        })
        .catch(error => {
            onError(error)
        })
    }
    static uploadBulkExamExerciseQuestions(
        payload: any,
        onSuccess: () => void,
        onError: (errors: any, row: any) => void,
        onFinal: () => void,
      ) {
        return axiosInstance
          .post(BULK_EXAM_EXERCISE_QUESTIONS, payload, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            onSuccess();
          })
          .catch((error) => {
            const { response } = error;
            onError(response?.data[0]?.error, response?.data[0]?.row);
            Notification({
              message: "Uploading failed",
              description: "Something went wrong",
              type: NotificationTypes.ERROR,
            });
          }).finally(onFinal)
        }
}